import { FormInputPropDto, FormInputType, FormType, MappedFormInputDto } from "ips/ac/model/api/WinDoFlow.api.types";
import { FormInput, FormInputProp } from "ips/ac/model/odata/generated/IpsCoreModel";

export default class FormInputFactory {
  public static cratedMappedFormInput(position: number, formInput: FormInput, formType: FormType, parentGuid?: string): MappedFormInputDto {
    return {
      guid: formInput.Guid,
      parentGuid: parentGuid,
      sId: formInput.Sid,
      isMandatory: !!formInput.IsMandatory,
      position: position,
      isUsedInternally: true,
      isUsedExternally: formType === FormType.SERVICE_REQUEST,
      description: formInput.Description,
      typeValue: FormInputType[formInput.Type_Value as keyof typeof FormInputType],
      properties: formInput.FormInputPropDetails?.map(prop => FormInputFactory.mapProperty(prop)) ?? [],
      children: formInput.ChildrenDetails?.map(child => FormInputFactory.cratedMappedFormInput(child.Position, child, null, formInput.Guid)) ?? [],
    };
  }

  private static mapProperty(prop: FormInputProp): FormInputPropDto {
    return {
      guid: prop.Guid,
      position: prop.Position,
      description: prop.Description,
    };
  }
}